import { useState } from 'react';
import {
  Row,
  Col,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Input,
  Button,
  InputGroup,
  InputGroupAddon,
} from 'reactstrap';
import { Master } from '../data';

import classnames from 'classnames';

const Filter = (props: any) => {
  const [searchCity, setSearchCity] = useState('');
  const [searchCategory, setSearchCategory] = useState('');
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prevState) => !prevState);

  const [activeTab, setActiveTab] = useState('1');
  const { categories, cities } = Master;

  const toggleTab = (tab: any) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  function filterSubmit() {
    toggle();
    props.filterSubmit();
  }

  function resetFilter() {
    toggle();
    props.resetFilter();
  }

  const [keyword, setKeyword] = useState(props.queryKeyword);

  const totalFilter = props.categoryFilter.length + props.cityFilter.length;

  return (
    <div className="FilterComponent d-flex">
      <form
        className="mr-3 flex-grow-1 flex-grow-lg-0"
        onSubmit={(e) => {
          e.preventDefault();
          props.searchSubmit(keyword);
        }}
      >
        <InputGroup>
          <Input placeholder="Cari Promo" className="border-bottom-only px-0" value={keyword} onChange={(e) => setKeyword(e.target.value)} />
          <InputGroupAddon addonType="append">
            <Button color="transparent">
              <i className="a-system-icon icon-search"></i>
            </Button>
          </InputGroupAddon>
        </InputGroup>
      </form>
      <Dropdown isOpen={dropdownOpen} toggle={toggle} direction="down">
        <DropdownToggle color="primary" outline={totalFilter === 0} className="rounded-pill">
          Filter {totalFilter > 0 ? <span className="total-filter">{totalFilter}</span> : <i className="a-system-icon icon-filter"></i>}
        </DropdownToggle>
        <DropdownMenu right={true} className="mt-3 filter-tabs-component py-0">
          <div className="d-flex d-sm-none m-header align-items-center">
            <h2 className="mr-auto">Filter</h2>
            <Button color="link" onClick={toggle}>
              <i className="a-system-icon icon-exit" />
            </Button>
          </div>
          <Nav tabs className="text-center">
            <NavItem className="w-50">
              <NavLink
                className={classnames({ active: activeTab === '1' })}
                onClick={() => {
                  toggleTab('1');
                }}
              >
                Kategori {props.categoryFilter.length > 0 && <span className="total-filter blue">{props.categoryFilter.length}</span>}
              </NavLink>
            </NavItem>
            <NavItem className="w-50">
              <NavLink
                className={classnames({ active: activeTab === '2' })}
                onClick={() => {
                  toggleTab('2');
                }}
              >
                Kota {props.cityFilter.length > 0 && <span className="total-filter blue">{props.cityFilter.length}</span>}
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent activeTab={activeTab} className="pt-3">
            <TabPane tabId="1">
              <Row className="mx-0">
                <Col sm="12" className="">
                  <InputGroup className="mb-3">
                    <Input
                      placeholder="Cari Kategori"
                      className="border-bottom-only px-0"
                      type="text"
                      onChange={(e) => setSearchCategory(e.currentTarget.value.toLowerCase())}
                    />
                    <InputGroupAddon addonType="append">
                      <Button color="transparent">
                        <i className="a-system-icon icon-search"></i>
                      </Button>
                    </InputGroupAddon>
                  </InputGroup>
                  <div className="list-items">
                    {categories
                      .filter((category: any) => category.name.toLowerCase().includes(searchCategory))
                      .map((filteredCategory: any, i) => (
                        <label className={`do-checkbox`} key={i} onChange={() => props.filterCategory(String(filteredCategory.slug))}>
                          <span dangerouslySetInnerHTML={{ __html: filteredCategory.name }} />
                          <input type="checkbox" checked={props.categoryFilter.includes(String(filteredCategory.slug))} readOnly />
                          <span className="checkmark"></span>
                        </label>
                      ))}
                  </div>
                </Col>
                <Col className="p-4 bottom-action">
                  <Button onClick={filterSubmit} color="primary" size="lg" className="rounded-pill w-100" disabled={props.categoryFilter.length === 0}>
                    Terapkan
                  </Button>
                  <Button onClick={resetFilter} color="link" className="w-100 text-decoration-none">
                    Reset Filter
                  </Button>
                </Col>
              </Row>
            </TabPane>
            <TabPane tabId="2">
              <Row className="mx-0">
                <Col sm="12" className="">
                  <InputGroup className="mb-3">
                    <Input
                      placeholder="Cari Kota"
                      className="border-bottom-only px-0"
                      type="text"
                      onChange={(e) => setSearchCity(e.currentTarget.value.toLowerCase())}
                    />
                    <InputGroupAddon addonType="append">
                      <Button color="transparent">
                        <i className="a-system-icon icon-search"></i>
                      </Button>
                    </InputGroupAddon>
                  </InputGroup>
                  <div className="list-items">
                    {cities
                      .filter((city: any) => city.name.toLowerCase().includes(searchCity))
                      .map((filteredCity: any, i: any) => (
                        <label className="do-checkbox" key={i} onChange={() => props.filterCity(String(filteredCity.slug))}>
                          <span dangerouslySetInnerHTML={{ __html: filteredCity.name }} />
                          <input type="checkbox" checked={props.cityFilter.includes(String(filteredCity.slug))} readOnly />
                          <span className="checkmark"></span>
                        </label>
                      ))}
                  </div>
                </Col>
                <Col className="p-4 bottom-action">
                  <Button onClick={filterSubmit} color="primary" size="lg" className="rounded-pill w-100">
                    Terapkan
                  </Button>
                  <Button onClick={resetFilter} color="link" className="w-100 text-decoration-none">
                    Reset Filter
                  </Button>
                </Col>
              </Row>
            </TabPane>
          </TabContent>
        </DropdownMenu>
      </Dropdown>
    </div>
  );
};

export default Filter;
